module.exports = __webpack_public_path__ + "img/suijing.d880fca9.png";